export default __webpack_public_path__ + "static/media/FJ.397a4822.svg";